import React, { useEffect, useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import { getDataFromStorage } from "../../util";
import DownloadSvgIcon from "../../Svg/DownloadSvgIcon";
import useS3FileManagement from "../../Hooks/useS3FileManagement";
import constants from "../../constants";
import axios from "../../api/axios";

// @ts-expect-error This does not exist outside of polyfill which this is doing
if (typeof Promise.withResolvers === "undefined") {
  if (window)
    // @ts-expect-error This does not exist outside of polyfill which this is doing
    window.Promise.withResolvers = function () {
      let resolve, reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });
      return { promise, resolve, reject };
    };
}

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

export const streamToUint8Array = async (stream) => {
  const chunks = [];

  for await (const chunk of stream) {
    chunks.push(chunk);
  }

  const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
  const uint8Array = new Uint8Array(totalLength);

  let offset = 0;
  for (const chunk of chunks) {
    uint8Array.set(chunk, offset);
    offset += chunk.length;
  }

  return uint8Array;
};

const PdfViewer = ({ path, isDownloadable, name, result }) => {
  // const { getS3Object } = useUploadLargeFileToS3();
  const { getS3Object, getPreSignedUrl, getS3FileAsFile } =
    useS3FileManagement();
  const [numPages, setNumPages] = useState(null);
  const [pdfDataUrl, setPdfDataUrl] = useState(null);

  useEffect(() => {
    const fetchPdfData = async () => {
      try {
        let url;


        if (result) {
          // console.log("Result:", result);
          setPdfDataUrl(result);
        } else {
          // console.log("result:");
          if (process.env.REACT_APP_DEPLOYMENT === "LOCAL") {
            url = { url: process.env.REACT_APP_NODE_API + path };
          } else {
            // const res = await getS3Object(path, undefined, "arraybuffer");
            // url = { data: new Uint8Array(res.data) };
            const { url: signedUrl } = await getPreSignedUrl(
              path,
              undefined,
              path?.split(".")?.pop(),
              "GET"
            );
            // console.log("url of pdf file", signedUrl);

            const res = await axios({
              method: "GET",
              url: signedUrl,
              responseType: "arraybuffer",
            });
            // console.log("data:",data);

            url = { data: new Uint8Array(res.data) };
            // console.log("url:",url);
          }
          setPdfDataUrl(url);
        }
      } catch (error) {
        console.error("Error fetching PDF data:", error);
      }
    };

    fetchPdfData();
  }, [path]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleDownload = async (path) => {
    let getCurrentLink = process.env.REACT_APP_NODE_API + path;
    if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
      let data = await getPreSignedUrl(
        path,
        undefined,
        path?.split(".")?.pop(),
        "GET"
      );
      getCurrentLink = data.url;
    }

    const anchorElement = document.createElement("a");
    anchorElement.download = name;
    // Change this line:
    anchorElement.href = getCurrentLink.url || getCurrentLink;
    anchorElement.setAttribute("target", "_blank");
    anchorElement.click();
  };

  return (
    <div className="pdfViewerContainer">
      {getDataFromStorage("role") === constants.Roles.learner && (
        <div className="pdfViewerFileNameSec">
          <p className="pdfViewerFileName">
            {name?.substring(0, name?.lastIndexOf("."))}
          </p>
          {isDownloadable && (
            <DownloadSvgIcon onClick={() => handleDownload(path)} />
          )}
        </div>
      )}
      {pdfDataUrl && (
        <Document
          file={pdfDataUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={(err) => console.error(err)}
          onSourceError={(err) => console.error(err)}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page pageNumber={index + 1} key={`page_${index + 1}`} />
          ))}
        </Document>
      )}
    </div>
  );
};

export default PdfViewer;
